import React from 'react';
import styles from './CommonModal.module.scss';
import {Button} from "@progress/kendo-react-buttons";
import {xIcon} from "@progress/kendo-svg-icons";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    simpleHeader?: boolean;
}

const CommonModal = ({ isOpen, onClose, title, children, simpleHeader }: ModalProps) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    {simpleHeader ? <div className={styles.simpleHeader}>{title}</div> : <h2>{title}</h2>}
                    <Button svgIcon={xIcon} className={styles.closeButton} onClick={onClose}>
                    </Button>
                </div>
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default CommonModal;
